import type { ReactNode } from 'react'
import { useTranslation } from '../../hooks/useTranslation'
import Money from '../../design/Money'

/** The small caption over a strip line. */
function Caption({ children }: { children: ReactNode }) {
  return <div className="text-cfd-label uppercase text-text-mid">{children}</div>
}

/** Idle, and while the order is rung up: hello. */
export function StageWelcome() {
  const { t } = useTranslation()
  return (
    <div className="motion-safe:animate-stageIn">
      <div className="font-volte-semibold text-cfd-title text-primary">{t('welcome')}</div>
    </div>
  )
}

/** A discount just landed: what the customer saved. */
export function StageSaved({ amount, seq, currency }: { amount: number; seq: number; currency: string }) {
  const { t } = useTranslation()
  return (
    <div key={seq} className="motion-safe:animate-stageIn">
      <Caption>{t('you-saved')}</Caption>
      <div className="mt-1 whitespace-nowrap font-volte-semibold text-cfd-title tabular-nums text-success">
        <Money amount={amount} currency={currency} lead />
      </div>
    </div>
  )
}

/** Paying: the amount. */
export function StagePay({ amount, currency }: { amount: number; currency: string }) {
  const { t } = useTranslation()
  return (
    <div className="motion-safe:animate-stageIn">
      <Caption>{t('to-pay')}</Caption>
      <div className="mt-1 whitespace-nowrap font-volte-semibold text-cfd-title tabular-nums text-primary">
        <Money amount={amount} currency={currency} lead />
      </div>
    </div>
  )
}

/** Paid. */
export function StageThanks() {
  const { t } = useTranslation()
  return (
    <div className="motion-safe:animate-stageIn">
      {/* Peak-end: the last thing they see is the one they remember. */}
      <div className="font-volte-semibold text-cfd-spot text-primary">{t('thank-you')}</div>
    </div>
  )
}
